export { default as DataDownload } from './component';
